import { useParams } from 'react-router-dom';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';

import { SimpleHeaderScreen } from 'Modules/layout';

const ProjectLayoutScreen = () => {
  const params = useParams();
  const studentId = params?.userId || params?.studentId;

  return (
    <SimpleHeaderScreen
      backCta={{
        label: translate('global.back_to_dashboard'),
        href: studentId
          ? getPathName(ROUTES.ADMIN.STUDENTS.DASHBOARD, { studentId })
          : ROUTES.DASHBOARD.PATHS,
      }}
      background="primary"
      isFixed
      isWide
      hasSmallLogo
    />
  );
};

export default ProjectLayoutScreen;
